import React from 'react';
import FormControl from '@mui/material/FormControl';
import { InputType } from '../input-type.enum';
import { TextField } from '@mui/material';
import { DateTimePicker } from '@mui/lab';
import { formatDate, formatTime } from '../../localization-helper';

export type CubitDateTimePickerAdapterProps = {
  type: InputType.DateRange | InputType.Date;
};

const CubitDateTimePickerAdapter: React.FC<CubitDateTimePickerAdapterProps> = (
  props: any
) => {
  const {
    id,
    name,
    input,
    field,
    label,
    style,
    variant,
    meta,
    formcontrolprops,
    ...rest
  } = props;

  const inputFormat = `${formatDate()} ${formatTime()}`;

  const value = input.value || null;

  const touched = meta.touched;
  const errorText = meta.error;

  return (
    <FormControl
      variant='standard'
      {...formcontrolprops}
      component='fieldset'
      style={style}>
      <DateTimePicker
        id={id || name || label}
        margin='none'
        label={label}
        autoOk
        format={inputFormat}
        inputVariant={variant}
        value={value ? new Date(value) : null}
        onChange={(date) => input.onChange(date?.toString())}
        renderInput={(params) => <TextField variant='standard' {...params} />}
        invalidDateMessage='Ugyldig datoformat'
        error={touched && errorText && errorText.length > 0}
        helperText={
          touched && errorText && errorText.length > 0 ? errorText : null
        }
        ampm={false}
        {...rest}
      />
    </FormControl>
  );
};

export default CubitDateTimePickerAdapter;
